module.exports = __webpack_public_path__ + "static/media/member nalas-08.c2a48de0.jpg";